<template>
    <div class="item-type-before-after">
        <div class="twentytwenty-container" ref="container">
            <div v-if="isBefore360" class="beforeViewer" ref="beforeViewer"></div>
            <img v-else class="before-image" :src="beforeImage" @load="beforeLoaded = true" />
            <div v-if="isAfter360" class="afterViewer" ref="afterViewer"></div>
            <img v-else class="after-image" :src="afterImage" @load="afterLoaded = true" />
        </div>
        <spinner v-show="!imagesLoaded || (isBefore360 || isAfter360 && !twentytwentyInit)" />
    </div>
</template>

<script>
import 'pannellum';
import { has } from 'lodash';
import { mapMutations, mapActions } from 'vuex';

import Spinner from '@/components/media/Spinner';

import 'pannellum/build/pannellum.css';

export default {
    name: 'BeforeAfter',
    components: {
        Spinner,
    },
    props: {
        item: {
            tyoe: Object
        }
    },
    data() {
        return {
            beforeLoaded: false,
            afterLoaded: false,
            beforeImageUrl: null,
            afterImageUrl: null,
            isBefore360: false,
            isAfter360: false,
            beforeViewer: null,
            afterViewer: null,
            pannellumNum: 0,
            twentytwentyInit: false,
            pannnellumInit: false,
            pannnellumOptions: {
                type: 'equirectangular',
                autoLoad: true,
                showZoomCtrl: true,
                showFullscreenCtrl: true,
                mouseZoom: false,
                hfov: 120,
                minHfov: 30,
                maxHfov: 120,
            },
            boss: null,
            nonBoss: null,
        }
    },
    watch: {
        imagesLoaded(value) {
            if (value) this.initTwentyTwenty();
        },
        beforeLabel() {
            this.setLabels('before');
        },
        afterLabel() {
            this.setLabels('after');
        },
        beforeMedia: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.getItem(newValue).then(response => {
                        console.log('beforeMedia', response);
                        this.isBefore360 = response.has360;
                        this.beforeImageUrl = `${response.url}?t=${response.timestamp}`;
                    }).catch(error => {
                         if (error.response.status === 404) {
                            this.beforeImageUrl = null;
                        }
                    });
                }
            }
        },
        afterMedia: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.getItem(newValue).then(response => {
                        console.log('afterMedia', response);
                        this.isAfter360 = response.has360;
                        this.afterImageUrl = `${response.url}?t=${response.timestamp}`;
                    }).catch(error => {
                        if (error.response.status === 404) {
                            this.afterImageUrl = null;
                        }
                    });
                }
            }
        },
        isBefore360: {
            handler(newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        this.beforeViewer = pannellum.viewer(this.$refs.beforeViewer, {panorama: `${this.beforeImage}&p=original`, ...this.pannnellumOptions});
                        this.beforeViewer.on('load', () => this.pannellumLoaded());
                        this.boss = this.beforeViewer;
                    });
                }
            }
        },
        isAfter360: {
            handler(newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        this.afterViewer = pannellum.viewer(this.$refs.afterViewer, {panorama: `${this.afterImage}&p=original`, ...this.pannnellumOptions});
                        this.afterViewer.on('load', () => this.pannellumLoaded());
                        this.nonBoss = this.afterViewer;
                    });
                }
            }
        },
        pannellumNum: {
            handler(newValue) {
                if (newValue === 2) {
                    this.initTwentyTwenty();
                }
            }
        },
        pannnellumInit: {
            handler(newValue) {
                if (newValue) {
                    $(window).trigger('resize.twentytwenty');
                }
            }
        },
        twentytwentyInit: {
            handler(newValue) {
                if (newValue) {
                    this.setLabels();
                }
            }
        },
    },
    computed: {
        /**
         * Gets `before_after` before media_id
         * @returns {string}
         */
        beforeMedia() {
            let id = false;
            const metadata = this.item.metadata;
            if (
                has(metadata, 'before_after') &&
                has(metadata.before_after, 'before') &&
                has(metadata.before_after.before, 'media_id')
            ) {
                id = metadata.before_after.before.media_id;
            }
            return id;
        },
        /**
         * Gets `before_after` after media_id
         * @returns {string}
         */
        afterMedia() {
            let id = false;
            const metadata = this.item.metadata;
            if (
                has(metadata, 'before_after') &&
                has(metadata.before_after, 'after') &&
                has(metadata.before_after.after, 'media_id')
            ) {
                id = metadata.before_after.after.media_id;
            }
            return id;
        },
        /**
         * Gets `before_after` before label
         * @returns {string}
         */
        beforeLabel(state) {
            let label = null;
            const metadata = this.item.metadata;
            if (
                has(metadata, 'before_after') &&
                has(metadata.before_after, 'before') &&
                has(metadata.before_after.before, 'label')
            ) {
                label = metadata.before_after.before.label;
            }
            return label;
        },
        /**
         * Gets `before_after` after label
         * @returns {string}
         */
        afterLabel(state) {
            let label = null;
            const metadata = this.item.metadata;
            if (
                has(metadata, 'before_after') &&
                has(metadata.before_after, 'before') &&
                has(metadata.before_after.after, 'label')
            ) {
                label = metadata.before_after.after.label;
            }
            return label;
        },
        beforeImage() {
            return this.beforeMedia ? this.beforeImageUrl : ca.config('media.placeholders.before_after');
        },
        afterImage() {
            return this.afterMedia ? this.afterImageUrl : ca.config('media.placeholders.before_after');
        },
        imagesLoaded() {
            return (this.beforeLoaded && this.afterLoaded);
        },
    },
    methods: {
        ...mapActions({
            getItem: 'fetchGalleryItem',
        }),
        ...mapMutations({
            setLabel: 'setMediaEditBeforeAfterLabel',
        }),
        initTwentyTwenty() {
            console.log('initTwentyTwenty');
            const container = this.$refs.container;
            $(container).twentytwenty({
                orientation: 'horizontal',
                no_overlay: true,
                move_slider_on_hover: false,
                move_with_handle_only: true,
                click_to_move: false,
            });

            this.$nextTick(() => {
                this.twentytwentyInit = true;
            });
        },
        setLabels(side) {
            const container = this.$refs.container;
            $('.twentytwenty-before-label', container)
                .addClass('twentytwenty-custom-label')
                .html(this.beforeLabel);

            $('.twentytwenty-after-label', container)
                .addClass('twentytwenty-custom-label')
                .html(this.afterLabel);
        },
        pannellumLoaded() {
            const that = this;
            this.pannellumNum++;
            if (this.pannellumNum < 2) return;
            this.pannnellumInit = true;

            $(this.beforeViewer.getContainer()).add($(this.afterViewer.getContainer())).on('mousedown', function() {
                that.boss = $(this).get(0) === that.beforeViewer.getContainer() ? that.beforeViewer : that.afterViewer;
                that.nonBoss = that.boss === that.afterViewer ? that.beforeViewer : that.afterViewer;
            });

            requestAnimationFrame(this.pannellumRender);
        },
        pannellumRender(timestamp) {
            this.nonBoss.lookAt(this.boss.getPitch(), this.boss.getYaw(), this.boss.getHfov(), false);
            requestAnimationFrame(this.pannellumRender);
        },
    }
}
</script>

<style lang="scss">
@import '~/sass/_variables';

.item-type-before-after {
    position: relative;
    width: 100%;
    height: 100%;
}

.beforeViewer, .afterViewer {
    position: absolute;
    width: 100%;
}

.pnlm-controls-container {
    top: 10px !important;
    left: 10px !important;
}

.twentytwenty-wrapper, .twentytwenty-container {
    width: 100%;
    height: 100%;
}

.twentytwenty-before-label:before, .twentytwenty-after-label:before {
    display: none;
}

.twentytwenty-custom-label.twentytwenty-before-label,
.twentytwenty-custom-label.twentytwenty-after-label {
    top: calc(50% - 60px) !important;
}
</style>
